import React, { useRef, useEffect, useState } from "react";
import "../video-annourcement.css";
const VideoAnnoucment = ({ setShowRequestVideo, url }) => {
  const [showPlayButton, setShowPlayButton] = useState(false);
  const handleClose = () => {
    setShowRequestVideo(false);
  };
  const handlePlay = () => {
    if (videoRef && videoRef.current) {
      videoRef.current.play();
      setShowPlayButton(false);
    }
  };
  const videoRef = useRef(null);
  useEffect(() => {
    const handleVideoEnded = () => {
      setShowRequestVideo(false);
    };

    if (videoRef && videoRef.current) {
      window.addEventListener("ended", handleVideoEnded, true);
      var promise = videoRef.current.play();
      if (promise !== undefined) {
        promise
          .then((_) => {
            console.log("autoplay started");
          })
          .catch((error) => {
            console.log("failed");
            setShowPlayButton(true);
            // Autoplay was prevented.
            // Show a "Play" button so that user can start playback.
          });
      }
    }
    return () => {
      window.removeEventListener("ended", handleVideoEnded, true);
    };
  }, [setShowRequestVideo]);
  return (
    <div className="video-annoucment">
      <div className="video-annoucment-inner">
        <div className="video-tight">
          <video
            src={`http://static.addfriends.com/video-messages/${url}.mp4`}
            autoPlay
            playsInline
            ref={videoRef}
            preload="auto"
            className="video-annoucement-actual"
          />
          {showPlayButton && (
            <div className="playbtn-annoucement">
              <i className="icon-play" onClick={handlePlay} />
            </div>
          )}
          <div className="close-annoucement">
            <i className="icon-close" onClick={handleClose} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoAnnoucment;
